export default __webpack_public_path__ + "static/media/applications-image-09.52e5952e.jpg";